import { rgba } from "polished";
import Theme from "../../Theme/client";

export type FieldDisplay = "normal" | "disabled" | "readonly";

export const colorPerDisplay: Record<FieldDisplay, string> = {
  normal: Theme.color,
  disabled: Theme.text.normal,
  readonly: rgba("black", 0.5),
};

export const backgroundPerDisplay: Record<FieldDisplay, string> = {
  normal: rgba(Theme.color, 0.1),
  disabled: rgba(Theme.text.normal, 0.1),
  readonly: "white",
};

export const borderColorPerDisplay: Record<FieldDisplay, string> = {
  normal: Theme.color,
  disabled: Theme.text.normal,
  readonly: "white",
};
